import React from 'react';

import { CommonLinkProps } from 'components/basic/Link/common.style';
import Link from 'components/basic/Link/Link';

type HttpString<T extends string> = T extends `https://${string}` ? T : never;

/**
 * Use this method on all places where we build markdown messages (eg. error messages),
 * so we can easily find all those places when needed for possible refactor.
 */
export function addExternalMarkdownLink<H extends string>(
  title: string,
  href: HttpString<H>
) {
  if (!href.startsWith('http')) {
    throw new Error('Only external links supported');
  }
  return `[${title}](${href})`;
}

/** Render message with Markdown Links if found in message */
export function renderSimpleMarkdownMessage(
  message: string,
  color?: CommonLinkProps['color']
) {
  const singleMarkdownLinkRegex = /^(.*)\[(.+)\]\((http\S+)\)(.*)$/i;
  // const str = `ZACIATOK [LINK HERE](https://linkhere.com) KONIEC`;
  const matches = singleMarkdownLinkRegex.exec(message);
  if (matches) {
    const [_all, start, linkTitle, link, end] = matches;
    return (
      <>
        {start}
        <Link href={link} color={color} underline>
          {linkTitle}
        </Link>
        {end}
      </>
    );
  }
  return message;
}
